import { render } from "./TalkRoomContents.vue?vue&type=template&id=35f55aa2&ts=true"
import script from "./TalkRoomContents.vue?vue&type=script&lang=ts&setup=true"
export * from "./TalkRoomContents.vue?vue&type=script&lang=ts&setup=true"

import "./TalkRoomContents.vue?vue&type=style&index=0&id=35f55aa2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/talkRoom/TalkRoomContents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35f55aa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35f55aa2', __exports__)) {
    api.reload('35f55aa2', __exports__)
  }
  
  module.hot.accept("./TalkRoomContents.vue?vue&type=template&id=35f55aa2&ts=true", () => {
    api.rerender('35f55aa2', render)
  })

}


export default __exports__